/**
 * Resize Widen image.
 *
 * Image requests are dynamic.
 *
 * @param {string} url Widen URL.
 * @param {number} x Width.
 * @param {number} y Height.
 * @param {boolean} crop Crop image.
 */
export function widenResize(url, x, y = null, crop = false) {
  if (!url) return "#";
  const protocol = url.slice(0, 8);
  let segments = url.slice(8).split("/");
  const oldQueryArgs = segments[segments.length - 1].split("?");
  const cropArg = crop ? "?keep=c&crop=yes" : "?keep=c&crop=no";

  segments.splice(segments.length - 2, 1, newDimensions(x, y));
  segments.splice(segments.length - 1, 1, oldQueryArgs[0]);

  return protocol + segments.join("/") + cropArg;
}

/**
 * New dimensions for Widen URL.
 *
 * @param {number} x Width.
 * @param {number} y Height.
 */
function newDimensions(x, y) {
  const dimensions = [x, y].filter(v => v).join("x");
  return `${dimensions}px`;
}

/**
 * Format dimensions.
 *
 * @param {string} dimensions Dimensions in the form of "4x20".
 */
export function formatDimensions(dimensions) {
  const [width, height] = dimensions.split("x");
  return `${width}" x ${height}"`;
}

/**
 * Array differences.
 *
 * @param {array} a First array.
 * @param {array} b Second array.
 *
 * @returns {array} Array of the values the arrays do not have in common.
 */
export function arrayDifferences(a, b) {
  let aValuesNotInB = a.filter(aVal => !b.includes(aVal));
  let bValuesNotInA = b.filter(bVal => !a.includes(bVal));
  return aValuesNotInB.concat(bValuesNotInA).sort();
}

/**
 * Returns if a string is an image based on URL structure from Widen.
 *
 *    Example video URL containing player:
 *         https://p.widencdn.net/ji9s0h/Masonite-New-HQ
 *
 *     Example image URL:
 *         https://embed.widencdn.net/img/masonite/thggyzhxrc/exact/MPS-LV-JG-DoubleDoor-Sitting-White-bty.jpeg
 *
 * @param {string} url The possible image string.
 * @return {boolean}
 */
export function isWidenImage(url) {
    let isImage = false;

    if (!url) {
        return false;
    }

    // Remove query string and/or hash from URL.
    url = url.split(/[?]/)[0];

    // If string has file extension, it's an image.
    isImage = url.match(/\.[0-9a-z]+$/i) ? true : false;

    return isImage;
}
